import { parse } from 'cache-control-parser';

/**
 * Compares two cache control values and returns the leser one
 */
export const compareCacheControl = (cacheControl: string, current = '') => {
  const existing = current && parse(current);
  const update = parse(cacheControl);

  if (
    existing &&
    ((existing['max-age'] && update['max-age'] && update['max-age'] > existing['max-age']) ||
      existing['no-store'] ||
      existing['no-cache'])
  ) {
    return current;
  }
  return cacheControl;
};
